import React, { useState } from 'react';
import { supabase } from '../supabase';
import './EquipmentPurchaseForm.css';


const EquipmentPurchaseForm = () => {
  const [transactionType, setTransactionType] = useState('');
  const [formData, setFormData] = useState({
    // Transaction Identification
    transactionRef: '',
    dateOfIssue: '',
    loiRef: '',
    currency: '',
    validityDeadline: '',
    // Buyer Details
    buyerName: '',
    buyerRegNo: '',
    buyerAddress: '',
    buyerCountry: '',
    buyerTin: '',
    buyerRepresentative: '',
    buyerEmail: '',
    buyerPhone: '',
    // Seller Details
    sellerName: '',
    sellerRegNo: '',
    sellerAddress: '',
    sellerCountry: '',
    sellerTin: '',
    sellerRepresentative: '',
    sellerEmail: '',
    sellerPhone: '',
    // Delivery
    deliveryAddress: '',
    portTerminal: '',
    siteContact: '',
    sitePhone: '',
    importerName: '',
    importerCountry: '',
    importerTin: '',
    beneficialOwner: '',
    // Equipment Schedule
    equipmentItems: [{ no: 1, equipment: '', manufacturer: '', serialNo: '', hsCode: '', origin: '', specification: '', qty: 1, unitPrice: '', totalPrice: '' }],
    // Equipment Condition
    equipmentCondition: '',
    manufactureYear: '',
    accessories: '',
    softwareLicences: '',
    voltage: '',
    warrantyMonths: '',
    spareParts: '',
    // Delivery
    incoterms: '',
    namedPlace: '',
    loadingPoint: '',
    destination: '',
    transportMode: '',
    shipmentWindowFrom: '',
    shipmentWindowTo: '',
    insurance: '',
    // Payment
    priceBasis: '',
    depositPercent: '',
    depositAmount: '',
    balancePercent: '',
    balanceMilestone: '',
    taxes: '',
    bankCharges: '',
    paymentMethod: '',
    // Documentary
    documents: [],
    // Inspection
    inspectionStage: '',
    inspectionAgency: '',
    acceptanceStandard: '',
    fatRequired: '',
    satRequired: '',
    acceptancePeriod: '',
    nonConformityRemedy: '',
    // Warranty
    warrantyScope: '',
    serviceResponseTime: '',
    sparePartsAvailability: '',
    training: '',
    softwareUpdates: '',
    // KYC
    kycVerified: false,
    beneficialOwnership: false,
    amlCompliance: false,
    exportControls: false,
    // ABVIG Role
    abvigRole: '',
    abvigFee: '',
    feeBasis: '',
    // Default
    curePeriod: '',
    governingLaw: '',
    disputeResolution: '',
    arbitrationRules: '',
    language: '',
    // Signatures
    buyerNameSigned: '',
    buyerTitle: '',
    buyerSignature: '',
    buyerDate: '',
    abvigName: '',
    abvigTitle: '',
    abvigSignature: '',
    abvigDate: '',
    agreeTerms: false
  });

  const [formStatus, setFormStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleEquipmentChange = (index, field, value) => {
    const items = [...formData.equipmentItems];
    items[index][field] = value;
    setFormData({ ...formData, equipmentItems: items });
  };

  const addEquipmentRow = () => {
    const items = [...formData.equipmentItems];
    items.push({ no: items.length + 1, equipment: '', manufacturer: '', serialNo: '', hsCode: '', origin: '', specification: '', qty: 1, unitPrice: '', totalPrice: '' });
    setFormData({ ...formData, equipmentItems: items });
  };

  const removeEquipmentRow = (index) => {
    if (formData.equipmentItems.length > 1) {
      const items = formData.equipmentItems.filter((_, i) => i !== index);
      items.forEach((item, i) => item.no = i + 1);
      setFormData({ ...formData, equipmentItems: items });
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);

    // Validation
    if (!formData.buyerName || !formData.buyerEmail || !formData.sellerName) {
      setFormStatus('error');
      setLoading(false);
      return;
    }

    try {
      // Submit to Supabase
      const { error } = await supabase
        .from('equipment_purchases')
        .insert([{
          transaction_type: transactionType,
          transaction_ref: formData.transactionRef,
          date_of_issue: formData.dateOfIssue,
          loi_ref: formData.loiRef,
          currency: formData.currency,
          buyer_name: formData.buyerName,
          buyer_reg_no: formData.buyerRegNo,
          buyer_address: formData.buyerAddress,
          buyer_country: formData.buyerCountry,
          buyer_tin: formData.buyerTin,
          buyer_representative: formData.buyerRepresentative,
          buyer_email: formData.buyerEmail,
          buyer_phone: formData.buyerPhone,
          seller_name: formData.sellerName,
          seller_reg_no: formData.sellerRegNo,
          seller_address: formData.sellerAddress,
          seller_country: formData.sellerCountry,
          seller_tin: formData.sellerTin,
          seller_representative: formData.sellerRepresentative,
          seller_email: formData.sellerEmail,
          seller_phone: formData.sellerPhone,
          delivery_address: formData.deliveryAddress,
          port_terminal: formData.portTerminal,
          importer_name: formData.importerName,
          importer_country: formData.importerCountry,
          incoterms: formData.incoterms,
          equipment_condition: formData.equipmentCondition,
          payment_method: formData.paymentMethod,
          governing_law: formData.governingLaw,
          status: 'pending'
        }]);

      if (error) throw error;
      
      setFormStatus('success');
    } catch (error) {
      console.error('Error submitting form:', error);
      setFormStatus('error');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="form-page">
      <section className="form-hero">
        <h1>Equipment Purchase Order / LOI Confirmation</h1>
        <p>For Equipment Acquisition, Import, Export and Cross-Border Purchase Transactions</p>
      </section>

      <section className="form-section">
        <div className="container">
          <div className="form-wrapper">
            <div className="form-header">
              <h2>Transaction Type — Select ONE</h2>
              <div className="type-selector">
                <button 
                  className={`type-btn ${transactionType === 'domestic' ? 'active' : ''}`}
                  onClick={() => setTransactionType('domestic')}
                >
                  ☐ Domestic
                </button>
                <button 
                  className={`type-btn ${transactionType === 'import' ? 'active' : ''}`}
                  onClick={() => setTransactionType('import')}
                >
                  ☐ Import
                </button>
                <button 
                  className={`type-btn ${transactionType === 'export' ? 'active' : ''}`}
                  onClick={() => setTransactionType('export')}
                >
                  ☐ Export
                </button>
                <button 
                  className={`type-btn ${transactionType === 'cross-border' ? 'active' : ''}`}
                  onClick={() => setTransactionType('cross-border')}
                >
                  ☐ Cross-Border / Triangular
                </button>
              </div>
            </div>

            {formStatus === 'success' && (
              <div className="form-success">
                <h3>✓ Purchase Order Submitted!</h3>
                <p>Your equipment purchase order has been received. Our team will contact you within 48 hours.</p>
              </div>
            )}

            {formStatus === 'error' && (
              <div className="form-error">
                <h3>⚠️ Submission Error</h3>
                <p>Please fill in all required fields.</p>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              {/* 1. Transaction Identification */}
              <div className="form-section-title">
                <h3>1. TRANSACTION IDENTIFICATION</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>PO / Transaction Reference No.</label>
                  <input type="text" name="transactionRef" value={`ABVIG-PO-${Date.now().toString().slice(-6)}`} disabled />
                </div>
                <div className="form-group">
                  <label>Date of Issue</label>
                  <input type="date" name="dateOfIssue" value={new Date().toISOString().split('T')[0]} disabled />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>LOI Reference / Date</label>
                  <input type="text" name="loiRef" value={formData.loiRef} onChange={handleChange} placeholder="Enter LOI reference" />
                </div>
                <div className="form-group">
                  <label>Currency *</label>
                  <select name="currency" value={formData.currency} onChange={handleChange} required>
                    <option value="">Select currency</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="GBP">GBP</option>
                    <option value="NGN">NGN</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              {/* 2. Parties */}
              <div className="form-section-title">
                <h3>2. PARTIES</h3>
              </div>

              <div className="form-subsection">
                <h4>BUYER / APPLICANT</h4>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label>Legal Name *</label>
                    <input type="text" name="buyerName" value={formData.buyerName} onChange={handleChange} required placeholder="Enter buyer name" />
                  </div>
                  <div className="form-group">
                    <label>Registration / Incorporation No.</label>
                    <input type="text" name="buyerRegNo" value={formData.buyerRegNo} onChange={handleChange} placeholder="Enter registration number" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input type="text" name="buyerAddress" value={formData.buyerAddress} onChange={handleChange} placeholder="Enter address" />
                </div>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label>Country / TIN</label>
                    <input type="text" name="buyerCountry" value={formData.buyerCountry} onChange={handleChange} placeholder="Country" />
                  </div>
                  <div className="form-group">
                    <label>Authorised Representative / Title</label>
                    <input type="text" name="buyerRepresentative" value={formData.buyerRepresentative} onChange={handleChange} placeholder="Name / Title" />
                  </div>
                </div>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="buyerEmail" value={formData.buyerEmail} onChange={handleChange} required placeholder="email@company.com" />
                  </div>
                  <div className="form-group">
                    <label>Telephone</label>
                    <input type="tel" name="buyerPhone" value={formData.buyerPhone} onChange={handleChange} placeholder="+234 800 000 0000" />
                  </div>
                </div>
              </div>

              <div className="form-subsection">
                <h4>SELLER / SUPPLIER</h4>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label>Legal Name *</label>
                    <input type="text" name="sellerName" value={formData.sellerName} onChange={handleChange} required placeholder="Enter seller name" />
                  </div>
                  <div className="form-group">
                    <label>Registration / Incorporation No.</label>
                    <input type="text" name="sellerRegNo" value={formData.sellerRegNo} onChange={handleChange} placeholder="Enter registration number" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Address</label>
                  <input type="text" name="sellerAddress" value={formData.sellerAddress} onChange={handleChange} placeholder="Enter address" />
                </div>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label>Country / TIN</label>
                    <input type="text" name="sellerCountry" value={formData.sellerCountry} onChange={handleChange} placeholder="Country" />
                  </div>
                  <div className="form-group">
                    <label>Authorised Representative / Title</label>
                    <input type="text" name="sellerRepresentative" value={formData.sellerRepresentative} onChange={handleChange} placeholder="Name / Title" />
                  </div>
                </div>
                <div className="form-row two-col">
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="sellerEmail" value={formData.sellerEmail} onChange={handleChange} required placeholder="email@company.com" />
                  </div>
                  <div className="form-group">
                    <label>Telephone</label>
                    <input type="tel" name="sellerPhone" value={formData.sellerPhone} onChange={handleChange} placeholder="+234 800 000 0000" />
                  </div>
                </div>
              </div>

              {/* 3. Equipment Schedule */}
              <div className="form-section-title">
                <h3>3. EQUIPMENT PURCHASE SCHEDULE</h3>
              </div>

              <div className="equipment-table">
                <div className="equipment-header">
                  <span className="col-no">#</span>
                  <span className="col-equipment">Equipment / Model</span>
                  <span className="col-manufacturer">Manufacturer / Brand</span>
                  <span className="col-serial">Serial No.</span>
                  <span className="col-hs">HS Code</span>
                  <span className="col-qty">Qty</span>
                  <span className="col-price">Unit Price</span>
                  <span className="col-total">Total</span>
                  <span className="col-action"></span>
                </div>
                {formData.equipmentItems.map((item, index) => (
                  <div className="equipment-row" key={index}>
                    <span className="col-no">{item.no}</span>
                    <input className="col-equipment" type="text" value={item.equipment} onChange={(e) => handleEquipmentChange(index, 'equipment', e.target.value)} placeholder="Equipment name" />
                    <input className="col-manufacturer" type="text" value={item.manufacturer} onChange={(e) => handleEquipmentChange(index, 'manufacturer', e.target.value)} placeholder="Manufacturer" />
                    <input className="col-serial" type="text" value={item.serialNo} onChange={(e) => handleEquipmentChange(index, 'serialNo', e.target.value)} placeholder="Serial No." />
                    <input className="col-hs" type="text" value={item.hsCode} onChange={(e) => handleEquipmentChange(index, 'hsCode', e.target.value)} placeholder="HS Code" />
                    <input className="col-qty" type="number" value={item.qty} onChange={(e) => handleEquipmentChange(index, 'qty', parseInt(e.target.value) || 1)} min="1" />
                    <input className="col-price" type="number" value={item.unitPrice} onChange={(e) => handleEquipmentChange(index, 'unitPrice', e.target.value)} placeholder="0.00" />
                    <span className="col-total">{item.qty * (parseFloat(item.unitPrice) || 0)}</span>
                    <button className="col-action" type="button" onClick={() => removeEquipmentRow(index)}>✕</button>
                  </div>
                ))}
                <button type="button" className="add-row-btn" onClick={addEquipmentRow}>+ Add Equipment</button>
              </div>

              {/* 4. Equipment Condition */}
              <div className="form-section-title">
                <h3>4. EQUIPMENT CONDITION & TECHNICAL REQUIREMENTS</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Condition</label>
                  <select name="equipmentCondition" value={formData.equipmentCondition} onChange={handleChange}>
                    <option value="">Select condition</option>
                    <option value="New">New</option>
                    <option value="Factory Refurbished">Factory Refurbished</option>
                    <option value="Used">Used</option>
                    <option value="Demonstration / Ex-Display">Demonstration / Ex-Display</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Manufacture Year / Serial No.</label>
                  <input type="text" name="manufactureYear" value={formData.manufactureYear} onChange={handleChange} placeholder="e.g., 2024" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Accessories / Configuration</label>
                  <input type="text" name="accessories" value={formData.accessories} onChange={handleChange} placeholder="List accessories" />
                </div>
                <div className="form-group">
                  <label>Software / Firmware / Licences</label>
                  <input type="text" name="softwareLicences" value={formData.softwareLicences} onChange={handleChange} placeholder="Software details" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Warranty</label>
                  <input type="text" name="warrantyMonths" value={formData.warrantyMonths} onChange={handleChange} placeholder="e.g., 12 months" />
                </div>
                <div className="form-group">
                  <label>Spare Parts / Consumables</label>
                  <input type="text" name="spareParts" value={formData.spareParts} onChange={handleChange} placeholder="Spare parts details" />
                </div>
              </div>

              {/* 5. Delivery & Incoterms */}
              <div className="form-section-title">
                <h3>5. DELIVERY, SHIPPING & INCOTERMS® 2020</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Agreed Incoterms® 2020 Rule</label>
                  <input type="text" name="incoterms" value={formData.incoterms} onChange={handleChange} placeholder="e.g., FCA / FOB / CIF / DAP / DDP" />
                </div>
                <div className="form-group">
                  <label>Named Place / Port / Point</label>
                  <input type="text" name="namedPlace" value={formData.namedPlace} onChange={handleChange} placeholder="Place / Port" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Loading / Dispatch Point</label>
                  <input type="text" name="loadingPoint" value={formData.loadingPoint} onChange={handleChange} placeholder="Loading point" />
                </div>
                <div className="form-group">
                  <label>Destination / Installation Site</label>
                  <input type="text" name="destination" value={formData.destination} onChange={handleChange} placeholder="Destination" />
                </div>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Transport Mode</label>
                  <select name="transportMode" value={formData.transportMode} onChange={handleChange}>
                    <option value="">Select mode</option>
                    <option value="Sea">Sea</option>
                    <option value="Air">Air</option>
                    <option value="Road">Road</option>
                    <option value="Rail">Rail</option>
                    <option value="Multimodal">Multimodal</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Shipment / Delivery Window</label>
                  <input type="text" name="shipmentWindow" value={formData.shipmentWindow} onChange={handleChange} placeholder="From - To" />
                </div>
              </div>

              {/* 6. Payment */}
              <div className="form-section-title">
                <h3>6. PURCHASE PRICE, PAYMENT & BANKING</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Price Basis</label>
                  <select name="priceBasis" value={formData.priceBasis} onChange={handleChange}>
                    <option value="">Select basis</option>
                    <option value="Fixed">Fixed</option>
                    <option value="Quotation valid until">Quotation valid until</option>
                    <option value="Formula / index-linked">Formula / index-linked</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Payment Method</label>
                  <select name="paymentMethod" value={formData.paymentMethod} onChange={handleChange}>
                    <option value="">Select method</option>
                    <option value="Documentary Credit (LC) subject to UCP 600">Documentary Credit (LC)</option>
                    <option value="Standby Letter of Credit (SBLC) subject to ISP98">Standby Letter of Credit (SBLC)</option>
                    <option value="Demand Guarantee subject to URDG 758">Demand Guarantee</option>
                    <option value="Irrevocable Bank Payment Undertaking">Irrevocable Bank Payment Undertaking</option>
                    <option value="Escrow / controlled account">Escrow / controlled account</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>

              {/* 7. Governing Law */}
              <div className="form-section-title">
                <h3>15. GOVERNING LAW & DISPUTE RESOLUTION</h3>
              </div>

              <div className="form-row two-col">
                <div className="form-group">
                  <label>Governing Law</label>
                  <input type="text" name="governingLaw" value={formData.governingLaw} onChange={handleChange} placeholder="e.g., Nigerian Law, English Law" />
                </div>
                <div className="form-group">
                  <label>Dispute Resolution</label>
                  <select name="disputeResolution" value={formData.disputeResolution} onChange={handleChange}>
                    <option value="">Select option</option>
                    <option value="Courts">Courts</option>
                    <option value="Arbitration">Arbitration</option>
                    <option value="Mediation then Arbitration">Mediation then Arbitration</option>
                  </select>
                </div>
              </div>

              {/* Signatures */}
              <div className="form-section-title">
                <h3>17. ACKNOWLEDGEMENT & SIGNATURES</h3>
              </div>

              <div className="form-subsection">
                <h4>BUYER / APPLICANT</h4>
                <div className="form-row three-col">
                  <div className="form-group">
                    <label>Name *</label>
                    <input type="text" name="buyerNameSigned" value={formData.buyerNameSigned} onChange={handleChange} required placeholder="Full name" />
                  </div>
                  <div className="form-group">
                    <label>Title</label>
                    <input type="text" name="buyerTitle" value={formData.buyerTitle} onChange={handleChange} placeholder="Job title" />
                  </div>
                  <div className="form-group">
                    <label>Date *</label>
                    <input type="date" name="buyerDate" value={formData.buyerDate} onChange={handleChange} required />
                  </div>
                </div>
              </div>

              <div className="form-subsection">
                <h4>ABVIG / TRANSACTION COORDINATOR</h4>
                <div className="form-row three-col">
                  <div className="form-group">
                    <label>Name</label>
                    <input type="text" name="abvigName" value={formData.abvigName} onChange={handleChange} placeholder="ABVIG Representative" />
                  </div>
                  <div className="form-group">
                    <label>Title</label>
                    <input type="text" name="abvigTitle" value={formData.abvigTitle} onChange={handleChange} placeholder="Title" />
                  </div>
                  <div className="form-group">
                    <label>Date</label>
                    <input type="date" name="abvigDate" value={formData.abvigDate} onChange={handleChange} />
                  </div>
                </div>
              </div>

              {/* Terms */}
              <div className="form-group checkbox">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="agreeTerms"
                    checked={formData.agreeTerms}
                    onChange={handleChange}
                    required
                  />
                  I confirm that all information provided is accurate and agree to the terms and conditions.
                </label>
              </div>

              <button type="submit" className="btn-gold submit-btn" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Purchase Order'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EquipmentPurchaseForm;